import { memo } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { BulkPeriodicPaymentTemplate } from 'components/templates/BulkPeriodicPaymentTemplate';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from 'components/templates/override.module.scss';
import { usePayPalClientId } from 'hooks/payment/UsePayPalClientId';

type Props = {};

export const BulkPeriodicPayment = memo((_props: Props) => {
	const { clientId, loading } = usePayPalClientId();

	if (loading) {
		return (
			<Backdrop className={classes.backdrop} open={loading}>
				<CircularProgress color="inherit" />
			</Backdrop>
		);
	}

	return (
		<PayPalScriptProvider
			options={{
				'client-id': clientId,
				components: 'buttons,hosted-fields',
				intent: 'tokenize',
				vault: true,
				currency: 'JPY',
				'data-namespace': 'paypal_sdk_bulk_periodic_payment',
			}}
		>
			<BulkPeriodicPaymentTemplate />
		</PayPalScriptProvider>
	);
});
